module.exports = __webpack_public_path__ + "static/media/bmo-onguard-ida-logo-EN.8a1affb1.svg";